import { Pipe, PipeTransform } from '@angular/core';

import { Observable, map } from 'rxjs';

import { getIn } from '@fcom/core/utils/data-utils';
import { isPresent } from '@fcom/core/utils/utils';

type UnsafeAny = ReturnType<typeof JSON.parse>;

@Pipe({
  name: 'finMap',
  standalone: false,
})
export class MapPipe implements PipeTransform {
  transform<T, U extends keyof T>(input: Observable<T>, selector: U | [U]): Observable<T[U]>;
  transform(input: Observable<unknown>, selector: string | string[]): Observable<UnsafeAny>;
  transform<T, U extends keyof T>(input: T, selector: U | [U]): T[U];
  transform(input: unknown, selector: string | string[]): UnsafeAny;
  transform(input: unknown, selector: string | string[]): UnsafeAny {
    if (input && typeof (input as unknown[]).map === 'function') {
      return (input as unknown[]).map((inp) => getIn(inp, selector));
    } else if (input && input instanceof Observable) {
      return input.pipe(map((inp) => getIn(inp, selector)));
    } else if (!isPresent(selector)) {
      return input;
    }
    return getIn(input, selector);
  }
}
